export const select2TextType = {
    placeholder: "",
    allowClear: false,
    minimumResultsForSearch: -1
}